import { isFunction } from 'util';

export enum Roles {
    Client_Liason_Officer = 'Client Liason Officer',
    Agent = 'Agent',
    AgencyAdministrator = 'AgencyAdministrator',
    Administrator = 'Administrator',
    Client = 'Client'
}

export namespace Roles {
  export function toList() {
    return Object.values(Roles).filter(
      (type) => isNaN(<any>type) && !isFunction(type)
    );
  }
}

